import { ref, watch } from "vue";
import bus from "@/lib/bus";
import { showToast, Skeleton } from "vant";
export default {
  props: ["type", "detailList"],
  components: {
    [Skeleton.name]: Skeleton
  },
  setup(props, context) {
    const setWidth = ref(window.innerWidth > 390 ? 120 : 100);
    const list = ref([]);
    const choiceBlock = ref(0); // 选中的商品
    const nowType = props;
    watch(nowType, newValue => {
      if (newValue) {
        list.value = newValue.detailList;
      }
    }, {
      deep: true
    });

    // 点击商品
    const choiceItem = e => {
      choiceBlock.value = e.id;
      if (e.game_stock == e.quantity && e.quantity >= 0 && e.type != 4) return showToast("不能再点啦~已经到达最大限购次数");
      if (e.game_stock == e.quantity && e.quantity >= 0 && e.type == 4) return showToast("已达最大购买次数，可前往“兑换记录”-“周边兑换”查看已兑换红包封面");
      if (e.stock == 0) {
        return showToast("暂无库存");
      }
      context.emit("choiceProduct", e);
    };
    bus.$on("clearProductList", () => {
      choiceBlock.value = 0;
    });
    const isMobile = () => {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };
    return {
      isMobile,
      choiceItem,
      choiceBlock,
      nowType,
      list,
      setWidth
    };
  }
};